"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tile = void 0;
var tile_1 = require("./tile");
Object.defineProperty(exports, "Tile", { enumerable: true, get: function () { return __importDefault(tile_1).default; } });
//# sourceMappingURL=index.js.map